module.exports = require("uuid");


//////////////////
// WEBPACK FOOTER
// external "uuid"
// module id = 26
// module chunks = 0